import cookie from "js-cookie";
import fetch from "isomorphic-fetch";
import { API } from "../config";

export const userSessionExpired = (response, history) => {
  if (response.status === 401) {
    signout(async () => {
      history.replace({
        pathname: "/company/signin",
        state: "Your session is expired. please signin.",
      });
    });
  } else {
    return;
  }
};
export const adminForgetPassword = () => {
  return fetch(`${API}/admin-forget-password`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
export const preSignup = (user) => {
  return fetch(`${API}/pre-signup`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
export const signup = (user) => {
  return fetch(`${API}/signup`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
export const AdminSignup = (user) => {
  return fetch(`${API}/admin-signup`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const signin = (user) => {
  return fetch(`${API}/signin`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
export const staffSignin = (user) => {
  return fetch(`${API}/staff-signin`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const companySignin = (user) => {
  return fetch(`${API}/company-signin`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const setCookie = (key, value) => {
  if (typeof window !== "undefined") {
    cookie.set(key, value, {
      expires: 1,
    });
  }
};
export const removeCookie = (key) => {
  if (typeof window !== "undefined") {
    cookie.remove(key, {
      expires: 1,
    });
  }
};
export const getCookie = (key) => {
  if (typeof window !== "undefined") {
    return cookie.get(key);
  }
};
export const setLocalstorage = (key, value) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(key, JSON.stringify(value));
  }
};
export const removeLocalstorage = (key) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(key);
  }
};

export const authentication = (data, next) => {
  setCookie("token", data.token);
  setLocalstorage("user", data.user);
  next();
};
export const signout = (next) => {
  removeCookie("token");
  removeLocalstorage("user");
  next();
  return fetch(`${API}/signout`, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      return err;
    });
};
export const isAuth = () => {
  if (typeof window !== "undefined") {
    const cookieChecked = getCookie("token");
    if (cookieChecked) {
      const storedUser = localStorage.getItem("user");
      if (!storedUser || storedUser === "undefined") {
        return false;
      }
      try {
        return JSON.parse(storedUser);
      } catch (err) {
        return false;
      }
    }
  }
};

export const forgotPassword = (email) => {
  return fetch(`${API}/forgot-password`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const resetPassword = (resetInfo) => {
  return fetch(`${API}/reset-password`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(resetInfo),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
export const checkCompanyEmail = (email) => {
  return fetch(`${API}/check-company-email`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const sendVerificationCode = (email) => {
  return fetch(`${API}/send-verification-code`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const verifyCode = (email, code) => {
  return fetch(`${API}/verify-code`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, code }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
export const companyResetPassword = (resetInfo) => {
  return fetch(`${API}/company-reset-password`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(resetInfo),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
export const companySignup = (user) => {
  const isFormData =
    typeof FormData !== "undefined" && user instanceof FormData;
  return fetch(`${API}/company-signup`, {
    method: "POST",
    headers: isFormData
      ? {
        Accept: "application/json",
      }
      : {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    body: isFormData ? user : JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const googleSigninAction = (idToken) => {
  return fetch(`${API}/google-signin`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ idToken }),
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const updateCompanyProfile = (profileData) => {
  const isFormData = typeof FormData !== "undefined" && profileData instanceof FormData;
  return fetch(`${API}/company-profile`, {
    method: "PUT",
    headers: isFormData
      ? { Accept: "application/json", Authorization: `Bearer ${getCookie("token")}` }
      : { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${getCookie("token")}` },
    body: isFormData ? profileData : JSON.stringify(profileData),
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const getCompanyProfile = () => {
  return fetch(`${API}/company-profile`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getCookie("token")}`,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};
